export const WithPlaceholder = ({ value }: { value: any }) => {
  if (value == null || value === '') {
    return <span className={'text-smallprint'}>N/A</span>;
  }

  return value;
};
